/* eslint-disable camelcase */
import {
  SETTLEMENT_REPORTS,
  SETTLEMENT_MISC_TRANSACTIONS,
  TAX_INVOICE_HISTORY,
  RESET,
} from '../types';

import { Settlement, TaxInvoices } from '@/api/api';

export const state = () => ({
  report: null,
  miscTransactions: null,
  tax: null,
});

export const getters = {
  [SETTLEMENT_REPORTS]({ report }) {
    return report;
  },

  [SETTLEMENT_MISC_TRANSACTIONS]({ miscTransactions }) {
    return miscTransactions;
  },

  [TAX_INVOICE_HISTORY]({ tax }) {
    return tax;
  },
};

/* eslint-disable no-param-reassign */
export const mutations = {
  [SETTLEMENT_REPORTS](stateObj, report) {
    stateObj.report = report;
  },

  [SETTLEMENT_MISC_TRANSACTIONS](stateObj, miscTransactions) {
    stateObj.miscTransactions = miscTransactions;
  },

  [TAX_INVOICE_HISTORY](stateObj, tax) {
    stateObj.tax = tax;
  },

  [RESET](stateObj) {
    Object.assign(stateObj, state());
  },
};

export const actions = {
  [SETTLEMENT_REPORTS]({ commit }) {
    return Settlement.getSettlementHistory()
      .then(({ body: { payment_history: history = [] } = {} }) => {
        commit(SETTLEMENT_REPORTS, [...history]);
      })
      .catch(({ body: { message = '' } = {} }) => Promise.reject(message));
  },

  [SETTLEMENT_MISC_TRANSACTIONS]({ commit }) {
    return Settlement.getMisc()
      .then(
        ({
          body: {
            reconciliation_miscellaneous_transactions: transactions = [],
          } = {},
        }) => {
          commit(SETTLEMENT_MISC_TRANSACTIONS, [...transactions]);
        },
      )
      .catch(({ body: { message = '' } = {} }) => Promise.reject(message));
  },

  [TAX_INVOICE_HISTORY]({ commit }) {
    return TaxInvoices.getTaxInvoicesHistory()
      .then(({ body: { tax_invoices = [] } = {} }) => {
        commit(TAX_INVOICE_HISTORY, [...tax_invoices]);
      })
      .catch(({ body: { message = '' } = {} }) => Promise.reject(message));
  },
};
export default {
  state,
  getters,
  mutations,
  actions,
};
